/* tslint:disable */
/* eslint-disable */
/**
 * notifications
 * notifications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type FindAllPreferences200Response,
    FindAllPreferences200ResponseFromJSON,
    FindAllPreferences200ResponseToJSON,
} from '../models/FindAllPreferences200Response';
import {
    type FindSmsDeliveryStatus200Response,
    FindSmsDeliveryStatus200ResponseFromJSON,
    FindSmsDeliveryStatus200ResponseToJSON,
} from '../models/FindSmsDeliveryStatus200Response';
import {
    type NotificationPreferenceDeliveryScope,
    NotificationPreferenceDeliveryScopeFromJSON,
    NotificationPreferenceDeliveryScopeToJSON,
} from '../models/NotificationPreferenceDeliveryScope';
import {
    type NotificationPreferenceSettings,
    NotificationPreferenceSettingsFromJSON,
    NotificationPreferenceSettingsToJSON,
} from '../models/NotificationPreferenceSettings';
import {
    type NotificationPreferencesUpdateRequest,
    NotificationPreferencesUpdateRequestFromJSON,
    NotificationPreferencesUpdateRequestToJSON,
} from '../models/NotificationPreferencesUpdateRequest';
import {
    type PreferenceDeliveryScopeApplyToAllRequest,
    PreferenceDeliveryScopeApplyToAllRequestFromJSON,
    PreferenceDeliveryScopeApplyToAllRequestToJSON,
} from '../models/PreferenceDeliveryScopeApplyToAllRequest';
import {
    type SuprSendGenerateJwtToken200Response,
    SuprSendGenerateJwtToken200ResponseFromJSON,
    SuprSendGenerateJwtToken200ResponseToJSON,
} from '../models/SuprSendGenerateJwtToken200Response';
import {
    type SuprSendJwtTokenRequest,
    SuprSendJwtTokenRequestFromJSON,
    SuprSendJwtTokenRequestToJSON,
} from '../models/SuprSendJwtTokenRequest';

export interface ApplyDeliveryScopesToAllPreferencesRequest {
    /**
     * 
     */
    preferenceDeliveryScopeApplyToAllRequest: PreferenceDeliveryScopeApplyToAllRequest;
}

export interface CreatePreferenceDeliveryScopeRequest {
    /**
     * 
     */
    notificationPreferenceDeliveryScope: NotificationPreferenceDeliveryScope;
    /**
     * 
     */
    selectAll?: boolean;
}

export interface CreatePreferenceSettingsRequest {
    /**
     * 
     */
    notificationPreferenceSettings: NotificationPreferenceSettings;
}

export interface FindAllPreferencesRequest {
    /**
     * 
     */
    userIds: string;
}

export interface FindSmsDeliveryStatusRequest {
    /**
     * 
     */
    userId: string;
}

export interface SuprSendGenerateJwtTokenRequest {
    /**
     * 
     */
    suprSendJwtTokenRequest: SuprSendJwtTokenRequest;
}

export interface UpdatePreferenceSettingsRequest {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    notificationPreferenceSettings: NotificationPreferenceSettings;
}

export interface UpdatePreferencesRequest {
    /**
     * 
     */
    notificationPreferencesUpdateRequest: NotificationPreferencesUpdateRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for applyDeliveryScopesToAllPreferences without sending the request
     */
    async applyDeliveryScopesToAllPreferencesRequestOpts(requestParameters: ApplyDeliveryScopesToAllPreferencesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['preferenceDeliveryScopeApplyToAllRequest'] == null) {
            throw new runtime.RequiredError(
                'preferenceDeliveryScopeApplyToAllRequest',
                'Required parameter "preferenceDeliveryScopeApplyToAllRequest" was null or undefined when calling applyDeliveryScopesToAllPreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/preference-delivery-scopes/apply-to-all`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PreferenceDeliveryScopeApplyToAllRequestToJSON(requestParameters['preferenceDeliveryScopeApplyToAllRequest']),
        };
    }

    /**
     * Copy delivery scopes from one notification preference to all others
     */
    async applyDeliveryScopesToAllPreferencesRaw(requestParameters: ApplyDeliveryScopesToAllPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.applyDeliveryScopesToAllPreferencesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Copy delivery scopes from one notification preference to all others
     */
    async applyDeliveryScopesToAllPreferences(requestParameters: ApplyDeliveryScopesToAllPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.applyDeliveryScopesToAllPreferencesRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createPreferenceDeliveryScope without sending the request
     */
    async createPreferenceDeliveryScopeRequestOpts(requestParameters: CreatePreferenceDeliveryScopeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationPreferenceDeliveryScope'] == null) {
            throw new runtime.RequiredError(
                'notificationPreferenceDeliveryScope',
                'Required parameter "notificationPreferenceDeliveryScope" was null or undefined when calling createPreferenceDeliveryScope().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['selectAll'] != null) {
            queryParameters['select_all'] = requestParameters['selectAll'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/preference-delivery-scopes`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPreferenceDeliveryScopeToJSON(requestParameters['notificationPreferenceDeliveryScope']),
        };
    }

    /**
     * Create Notification Preference Delivery Scope
     */
    async createPreferenceDeliveryScopeRaw(requestParameters: CreatePreferenceDeliveryScopeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createPreferenceDeliveryScopeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create Notification Preference Delivery Scope
     */
    async createPreferenceDeliveryScope(requestParameters: CreatePreferenceDeliveryScopeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPreferenceDeliveryScopeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for createPreferenceSettings without sending the request
     */
    async createPreferenceSettingsRequestOpts(requestParameters: CreatePreferenceSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationPreferenceSettings'] == null) {
            throw new runtime.RequiredError(
                'notificationPreferenceSettings',
                'Required parameter "notificationPreferenceSettings" was null or undefined when calling createPreferenceSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/preference-settings`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPreferenceSettingsToJSON(requestParameters['notificationPreferenceSettings']),
        };
    }

    /**
     * Create User Type Preference settings
     */
    async createPreferenceSettingsRaw(requestParameters: CreatePreferenceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.createPreferenceSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create User Type Preference settings
     */
    async createPreferenceSettings(requestParameters: CreatePreferenceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createPreferenceSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for findAllPreferences without sending the request
     */
    async findAllPreferencesRequestOpts(requestParameters: FindAllPreferencesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userIds'] == null) {
            throw new runtime.RequiredError(
                'userIds',
                'Required parameter "userIds" was null or undefined when calling findAllPreferences().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userIds'] != null) {
            queryParameters['user_ids'] = requestParameters['userIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/preferences`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get all preferences
     */
    async findAllPreferencesRaw(requestParameters: FindAllPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindAllPreferences200Response>> {
        const requestOptions = await this.findAllPreferencesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindAllPreferences200ResponseFromJSON(jsonValue));
    }

    /**
     * Get all preferences
     */
    async findAllPreferences(requestParameters: FindAllPreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindAllPreferences200Response> {
        const response = await this.findAllPreferencesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for findSmsDeliveryStatus without sending the request
     */
    async findSmsDeliveryStatusRequestOpts(requestParameters: FindSmsDeliveryStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling findSmsDeliveryStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['userId'] != null) {
            queryParameters['user_id'] = requestParameters['userId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/preferences/sms-delivery-status`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Get whether a user\'s SMS notifications were auto-disabled due to delivery failures
     */
    async findSmsDeliveryStatusRaw(requestParameters: FindSmsDeliveryStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindSmsDeliveryStatus200Response>> {
        const requestOptions = await this.findSmsDeliveryStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindSmsDeliveryStatus200ResponseFromJSON(jsonValue));
    }

    /**
     * Get whether a user\'s SMS notifications were auto-disabled due to delivery failures
     */
    async findSmsDeliveryStatus(requestParameters: FindSmsDeliveryStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindSmsDeliveryStatus200Response> {
        const response = await this.findSmsDeliveryStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for suprSendGenerateJwtToken without sending the request
     */
    async suprSendGenerateJwtTokenRequestOpts(requestParameters: SuprSendGenerateJwtTokenRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['suprSendJwtTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'suprSendJwtTokenRequest',
                'Required parameter "suprSendJwtTokenRequest" was null or undefined when calling suprSendGenerateJwtToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/suprsend/generate-jwt-token`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SuprSendJwtTokenRequestToJSON(requestParameters['suprSendJwtTokenRequest']),
        };
    }

    /**
     * Generate JWT token for SuprSend integration
     */
    async suprSendGenerateJwtTokenRaw(requestParameters: SuprSendGenerateJwtTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SuprSendGenerateJwtToken200Response>> {
        const requestOptions = await this.suprSendGenerateJwtTokenRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuprSendGenerateJwtToken200ResponseFromJSON(jsonValue));
    }

    /**
     * Generate JWT token for SuprSend integration
     */
    async suprSendGenerateJwtToken(requestParameters: SuprSendGenerateJwtTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SuprSendGenerateJwtToken200Response> {
        const response = await this.suprSendGenerateJwtTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for updatePreferenceSettings without sending the request
     */
    async updatePreferenceSettingsRequestOpts(requestParameters: UpdatePreferenceSettingsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updatePreferenceSettings().'
            );
        }

        if (requestParameters['notificationPreferenceSettings'] == null) {
            throw new runtime.RequiredError(
                'notificationPreferenceSettings',
                'Required parameter "notificationPreferenceSettings" was null or undefined when calling updatePreferenceSettings().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/preference-settings/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPreferenceSettingsToJSON(requestParameters['notificationPreferenceSettings']),
        };
    }

    /**
     * Update User Type Preference settings
     */
    async updatePreferenceSettingsRaw(requestParameters: UpdatePreferenceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updatePreferenceSettingsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update User Type Preference settings
     */
    async updatePreferenceSettings(requestParameters: UpdatePreferenceSettingsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePreferenceSettingsRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updatePreferences without sending the request
     */
    async updatePreferencesRequestOpts(requestParameters: UpdatePreferencesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['notificationPreferencesUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'notificationPreferencesUpdateRequest',
                'Required parameter "notificationPreferencesUpdateRequest" was null or undefined when calling updatePreferences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/preferences`;

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NotificationPreferencesUpdateRequestToJSON(requestParameters['notificationPreferencesUpdateRequest']),
        };
    }

    /**
     * Update User Type Preferences
     */
    async updatePreferencesRaw(requestParameters: UpdatePreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updatePreferencesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update User Type Preferences
     */
    async updatePreferences(requestParameters: UpdatePreferencesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePreferencesRaw(requestParameters, initOverrides);
    }

}
